import React, { Component } from 'react'
import { Button, Icon, Checkbox, Alert, Pagination, Spin, Tooltip } from 'antd'
import { FilterType, FilterSearch, FilterTags, AssignTags } from '../../../../components/Parts'

export default class LibraryTable extends Component {
  handleCheckCheckobox = (file) => {
    const { addTableItem, removeTableItem, table } = this.props

    if (table.keys.includes(file.id)) {
      removeTableItem(file.id)
    } else {
      addTableItem(file.id, file)
    }
  }

  handleCheckAll = () => {
    const { table, files, setTable } = this.props

    if (table.rows.length && table.rows.length === files.length) {
      setTable([], [])
    } else {
      const keys = files.map(file => file.id)
      const rows = files
      setTable([], [])
      setTable(keys, rows)
    }
  }

  onClickcreateStorageAssignmentByArray = () => {
    const { table, setTable, selectedDirectory, selectedChannel, createStorageAssignmentByArray } = this.props

    const storageId = selectedDirectory.id ? selectedDirectory.id : selectedChannel.id
    const guids = {
      guids: table.rows.map(item => item.guid)
    }

    createStorageAssignmentByArray(storageId, guids).then((response) => {
      setTable([], [])
    })
  }

  handlePage = (page) => {
    this.props.setFilterPagination(page - 1)
  }

  handlePageSize = (page, pageSize) => {
    this.props.setFilterPagination(page - 1, pageSize)
  }

  render () {
    const { selectedChannel, selectedDirectory, table, files, filters, storage } = this.props

    const indeterminate = !!table.rows.length && (table.rows.length < files.length)
    const checked = files.length && table.rows.length === files.length && table.keys[0] === files[0].id

    return (
      <div className='table' style={{ overflow: 'initial' }}>
        <div className='table-header table__header'>
          <div className='table-header__control'>
            <Checkbox
              indeterminate={indeterminate}
              checked={checked}
              onChange={this.handleCheckAll} />
          </div>
          <div className='table-header__control'>
            <FilterType />
          </div>
          <div className='table-header__control'>
            <FilterTags />
          </div>
          { table.keys.length > 0 &&
            <div className='table-header__control'>
              <AssignTags />
            </div>
          }
          <div className='table-header__control'>
            <FilterSearch />
          </div>

        </div>

        <Spin spinning={storage.isFetching}>
          <div className='table__content'>
            { files.length > 0 ? files.map((file, index) =>
              <div key={index} className='table-item table__item'>
                <div className='table-item__control'>
                  <Checkbox
                    onChange={() => this.handleCheckCheckobox(file)}
                    checked={table.keys.includes(file.id)} />
                </div>
                <div className='table-item__info'>
                  <div className='table-item__name'>{ file.name + '.' + file.extension }</div>
                  { file.tags &&
                  <div className='user-cell__groups'>
                    { file.tags.map((tag, index) => <div key={index} className='user-cell__group'>{ tag.value }</div>) }
                  </div> }
                </div>
              </div>
            ) : <Alert message='Assets Not Found' type='warning' showIcon /> }
          </div>
        </Spin>

        <div className='table-footer table__footer'>
          <div className='table-footer__control'>
            <Pagination
              total={storage.data.nestedCount}
              defaultCurrent={1}
              current={filters.page + 1}
              showSizeChanger
              pageSize={filters.pageSize}
              pageSizeOptions={['10', '20', '50']}
              onChange={this.handlePage}
              onShowSizeChange={this.handlePageSize}
            />
          </div>
          <div className='table-footer__control table-footer__control_last'>
            { (selectedDirectory && selectedDirectory.type === 'SMART_DIRECTORY')
              ? <Tooltip title={`You can't move files to Smart Folder`}>
                <Button
                  style={{ marginLeft: 'auto' }}
                  type='indigo'
                  disabled
                >Move <Icon type='arrow-right' /></Button>
              </Tooltip>
              : <Button
                style={{ marginLeft: 'auto' }}
                type='indigo'
                disabled={table.rows.length === 0 || !selectedChannel.id}
                onClick={this.onClickcreateStorageAssignmentByArray}
              >Move <Icon type='arrow-right' /></Button>}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Channels/components/TableLibrary/TableLibrary.jsx